import { DataTableStatusCell } from "@maysoft/common-component-react";
import { useMemo } from "react";

import { Status } from "../../constants/enums";
import useStrings from "../../hooks/useStrings";

const PublishCell = ({ status, publishReady }: { status: Status; publishReady?: boolean }) => {
    const Strings = useStrings();
    const language = Strings.getLanguage();

    const data = useMemo<{
        icon: string;
        title: string;
        color: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark" | "light" | "white" | "default";
    }>(() => {
        // if (status === PublishedStatus.Unpublishing) return { icon: "cancel", color: "error", title: Strings.Common.UNPUBLISHING };
        // if (status === PublishedStatus.Publishing) return { icon: "more_horiz", color: "warning", title: Strings.Common.PUBLISHING };
        if (status === Status.Inactive) return { icon: "drafts", color: "secondary", title: Strings.Common.UNPUBLISHED };
        if (status === Status.Active) return { icon: "check", color: "success", title: Strings.Common.PUBLISHED };
        return { icon: "drafts", color: "secondary", title: Strings.Common.UNKNOWN };
    }, [status, language]);

    return <DataTableStatusCell data={data} />;
};

export default PublishCell;
